import { useNavigate } from 'react-router-dom';
import { getChartData } from './reducers/helpers';
import { useSaveChartFromData } from './saveChartFromData';
import { useSettingsContext } from '../components/Contexts/SettingsContext/SettingsContext';
import { getDashboardParamForExploreRoute } from '../helpers';

export const useSaveChartToDashboard = () => {
    const navigate = useNavigate();
    const settings = useSettingsContext();

    const { saveChartFromData } = useSaveChartFromData(
        (widget, redirect, dashboardSlug) => {
            navigate(
                `/explore/${widget.chart?.key}${getDashboardParamForExploreRoute(dashboardSlug)}`,
            );
            if (redirect && dashboardSlug && widget.chart?.key) {
                setTimeout(
                    () =>
                        widget.chart &&
                        navigate(
                            `/dashboard/${dashboardSlug}#grid-chart-${widget.chart.key}`,
                        ),
                    200,
                );
            }
        },
    );

    const saveChartToDashboard = (payload: {
        dashboard: { key: number; slug: string };
        explore: ExploreQueryT;
        redirect: boolean;
        snackAction: boolean;
        fromPosition?: FromPositionQueryT;
    }) => {
        const { dashboard, explore, redirect, snackAction, fromPosition } =
            payload;
        const chartData = getChartData(explore, settings);
        saveChartFromData({
            dashboard,
            chartData,
            redirect,
            snackAction,
            fromPosition,
        });
    };

    return { saveChartToDashboard };
};
